// src/components/customer-search/SaveFilterDialog.tsx
import React, { useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Alert
} from '@mui/material';

interface SaveFilterDialogProps {
  open: boolean;
  onClose: () => void;
  onSave: (name: string) => void;
  existingNames: string[]; // To check for duplicates
}

const SaveFilterDialog: React.FC<SaveFilterDialogProps> = ({ open, onClose, onSave, existingNames }) => {
  const [name, setName] = useState('');
  const [error, setError] = useState<string | null>(null);

  const handleSave = () => {
    const trimmedName = name.trim();
    if (!trimmedName) {
      setError('Namn får inte vara tomt.');
      return;
    }
    if (existingNames.includes(trimmedName.toLowerCase())) {
       setError('Det finns redan ett filter med detta namn.');
       return;
    }
    setError(null);
    onSave(trimmedName);
    setName(''); // Reset name after save
    onClose();
  };

  const handleClose = () => {
    setName(''); // Reset name on close
    setError(null);
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Spara filtervy</DialogTitle>
      <DialogContent>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        <TextField
          autoFocus
          margin="dense"
          id="filter-name"
          label="Filternamn"
          type="text"
          fullWidth
          variant="standard"
          value={name}
          onChange={(e) => setName(e.target.value)}
          onKeyPress={(e) => {
             if (e.key === 'Enter') {
               handleSave();
             }
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Avbryt</Button>
        <Button onClick={handleSave} variant="contained">Spara</Button>
      </DialogActions>
    </Dialog>
  );
};

export default SaveFilterDialog;